module.exports = __webpack_public_path__ + "img/asc.342c869a.svg";